const stripTrailingSlash = str => {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};

export default stripTrailingSlash;
